import React, {useContext, useEffect, useState} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {useNavigate, useParams} from 'react-router-dom';
import {Col, Row} from "react-bootstrap";
import {AuthContext} from "../../context/authContext";
import CurrentUser, {dataForSelect, handleGqlFormErrors, selectedValue} from "../../helpers/Api";
import FlashMessage from "../shared/FlashMessage";
import Select from "react-select";
import {getActivePlans} from "../pages/PlanQueries";
import {REGISTER_MUTATION} from "./UserQueries";
import isEmpty from 'lodash/isEmpty'

const Register = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  if (CurrentUser()?.type) {
    navigate('/profile')
  }

  const params = useParams()
  const [flash, setFlash] = useState({});
  const { data: plansData } = useQuery(getActivePlans)

  const [formState, setFormState] = useState({
    plan_id: params.planId || (plansData && plansData.activePlans[0].id),
    f_name: '',
    l_name: '',
    phone: '',
    email: '',
    password: ''
  });

  useEffect(() => {
    if (plansData && plansData.activePlans[0].id != formState.plan_id)
      setFormState({ ...formState, plan_id: plansData.activePlans[0].id })
  }, [plansData, formState])

  if (params.errors && isEmpty(flash))
    setFlash({ type: 'danger', message: params.errors })

  const [registerCall] = useMutation(REGISTER_MUTATION)

  const onSubmit = event => {
    event.preventDefault()
    registerCall({
      variables: {
        planId: formState.plan_id,
        email: formState.email,
        password: formState.password,
        phone: formState.phone,
        fName: formState.f_name,
        lName: formState.l_name,
      },
      onCompleted: ({ registerUser: data }) => {
        if (data && data.token) {
          login(data)
          navigate('/profile')
        } else {
          setFlash({ type: 'danger', message: 'Data could not be saved' })
        }
      },
      onError: ({ graphQLErrors }) => {
        handleGqlFormErrors(event.target.closest('form'), graphQLErrors, setFlash)
      }
    });
  }

  const handlePlanChange = (option, field) => {
    setFormState({
      ...formState,
      [field.name]: option.value
    })
  }

  const updateFormState = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div
      className="position-absolute top-50 start-50 translate-middle w-75 register-form bg-lighter-branding p-4 rounded shadow">
      <form>
        <h1 className="h3 mb-3 fw-normal">Inregistrare</h1>
        <FlashMessage flash={flash} align="center" />
        <Row className="mb-3">
          <Col><label htmlFor="plan_id">Plan</label></Col>
          <Col sm={8}>
            {plansData &&
              <Select name='plan_id' id="plan_id" className="basic-single"
                      onChange={handlePlanChange}
                      options={dataForSelect(plansData.activePlans)}
                      defaultValue={selectedValue(plansData.activePlans, formState.plan_id || plansData.activePlans[0].id)}
              />
            }
          </Col>
        </Row>
        <Row className="mb-3">
          <Col><label htmlFor="f_name">Prenume</label></Col>
          <Col sm={8}>
            <input type='text' name='f_name' className="form-control" id="f_name"
                   onChange={updateFormState} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col><label htmlFor="l_name">Nume</label></Col>
          <Col sm={8}>
            <input type="text" name='l_name' className="form-control" id="l_name"
                   onChange={updateFormState} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col><label htmlFor="phone">Telefon</label></Col>
          <Col sm={8}>
            <input type="text" name='phone' className="form-control" id="phone"
                   onChange={updateFormState} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <label htmlFor="email">Email</label>
          </Col>
          <Col sm={8}>
            <input type="email" name="email" className="form-control border-0 border-bottom bg-white" id="email"
                   placeholder="email@example.com" onChange={updateFormState} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <label htmlFor="password">Parola</label>
          </Col>
          <Col sm={8}>
            <input type="password" name="password" className="form-control border-0 border-bottom bg-white"
                   id="password" placeholder="name@example.com" onChange={updateFormState} />
          </Col>
        </Row>
        <button className="w-100 btn btn-lg btn-primary" type="submit" onClick={onSubmit}>Inregistreaza-te</button>
        {/*<NavLink to='/'>Home</NavLink>*/}
        {/*<NavLink to='/login' className='float-end'>Am cont</NavLink>*/}
      </form>
    </div>
  )
}

export default Register
